// src/pages/fiscal/mdfe/SeguradoraSearch.js
import React from 'react';
import CadastroFiscalSearch from './CadastroFiscalSearch';

const SeguradoraSearch = ({ show, onHide, onSelectSeguradora, registros = [] }) => (
  <CadastroFiscalSearch show={show} onHide={onHide} titulo="Buscar Seguradora" registros={registros}
    campos={['nome', 'cnpj']} onSelect={onSelectSeguradora} />
);
export default SeguradoraSearch;
